import { ArtboardFilter } from '../../artboard-gl/types'

export function labelFromArtboardFilter(filter?: ArtboardFilter) {
    switch (filter) {
        case 'grayscale':
            return 'Black & White'
        case 'rainbow':
            return 'Rainbow'
        case 'rumble':
            return 'Rumble'
        case 'vhs':
            return 'VHS'
        case 'wavy':
            return 'Groovy'
        default:
            return 'No Filter'
    }
}
